$('.slideshow_inner_cls').slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: false,
    adaptiveHeight: true,
    arrows: false
  });
$('.history-btn, .history-close').on('click', function(e){
    e.preventDefault();
    $('.history-modal').toggleClass('is-active');
})

// Custom Testimonial Slider
        $('.testimonials-slider').slick({
          arrows: true,
          dots: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          speed: 300,
          cssEase: 'linear',
          variableWidth: true,
            responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: false,
          },
        },
      ]
      });

  $(".custom-add-to-cart").on("click", function() {
    var prodId = $(this).data("variant-id");
    let formData = {
     'items': [{
      'id': prodId,
      'quantity': 1
      }]
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      Shopify.theme.jsAjaxCart.updateView();
      Shopify.theme.jsAjaxCart.showDrawer();
      // return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  
  });

function fbt_section() {
  $('.index .custom_pro_slider').slick({
          arrows: false,
          dots: true,
          slidesToShow: 3,
          cssEase: 'linear',
          slidesToScroll: 1,
          infinite: false,
          autoplay: false,
          responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            rows:1
          },
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 577,
          settings: {
            arrows: true,
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ]
      });
}
fbt_section();

jQuery(window).on('load', fbt_section);

jQuery(window).on('resize orientationchange', function(){
  $('.custom_pro_slider').slick('refresh');
});

$('.tablinks').on('click', function(){
  $('.custom_pro_slider').slick('refresh');
});

$('.tab-accordion-wrapper-mobile').children().on('click', function(){
  $('.custom_pro_slider').slick('refresh');
});
  
  $(document).ready(function(){
    if(window.outerWidth > 425) {
    function getMinHeight(){
      var height = $('.custom_pro_slider .product-thumbnail__title').height();
      $('.product-thumbnail__title').css('min-height',height)
    }
    getMinHeight();
    };
  });

  setInterval(function(){
    if(document.querySelector('[data-testid="form-row"]')){
      document.querySelector('[data-testid="form-row"] button').classList.add('btn-01');
    } 
  },500);




$(document).ready(function(){
    function getMaxHeight(){
      var height = $('.block-description').height();
      $('.block-description').css('min-height',height)
    }
    getMaxHeight();
  });

// BFSM landing page 
$('.column-title').matchHeight();
  
// var swiper = new Swiper(".swiper-container", {
// autoplay: {
//           delay: 2500,
//           disableOnInteraction: false,
//         },
//  });

// var swiper = new Swiper(".new-product-list .swiper-container", {
//   autoplay: false
// });

function c_fbt_section() {
  $('.collection-new .custom_pro_slider').slick({
          arrows: false,
          dots: true,
          row:2,
          slidesToShow: 4,
          cssEase: 'linear',
          slidesToScroll: 1,
          infinite: false,
          autoplay: false,
          responsive: [
         {
			    breakpoint: 5000,
			    settings: "unslick"
		},
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            rows:1
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 577,
          settings: {
            arrows: true,
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ]
      });
}
c_fbt_section();
jQuery(window).on('load resize orientationchange', c_fbt_section);

// matchheight for Product grid on collection page
setTimeout(function() {
  // $('body.collection .product__thumbnail.product__gridItem').matchHeight();
  // $('body.collection .product-wrap').matchHeight();

  // $('body.collection .product-wrap .product-image__wrapper').matchHeight();
  // $('body.collection .product-wrap .thumbnail__caption').matchHeight();
  // $('body.collection .product-wrap .product-thumbnail').matchHeight();

$.fn.matchHeight._update();
}, 5000);

window.setGridHeight = (selector) =>{
  this.heightArray = [];
  this.offsetArrayArray = [];
  this.sectionArray = [];


  document.querySelectorAll(selector).forEach((grid,i)=>{
    var tmp = {'index':i,'offsetheight':grid.closest(`.collection-matrix`).offsetTop};
    this.offsetArrayArray.push(tmp)
  });

  this.diffrentsHeights = []
  this.offsetArrayArray.forEach(function(e){
    if(this.diffrentsHeights.includes(e.offsetheight) == false){
      this.diffrentsHeights.push(e.offsetheight)
    }
  })

  this.diffrentsHeights.forEach(function(e){
    var data = [];
    for(var i = 0; i < this.offsetArrayArray.length; i++){
      if(this.offsetArrayArray[i].offsetheight == e){
        data.push(this.offsetArrayArray[i]);
      }
    }

    var getAllHeightArray = [];
    data.forEach(function(ele){
      document.querySelectorAll(selector)[ele.index].removeAttribute('style');
      getAllHeightArray.push(document.querySelectorAll(selector)[ele.index].offsetHeight);
    })

    var getMaxHeight = Math.max.apply(Math, getAllHeightArray);
    data.forEach(function(ele){
      document.querySelectorAll(selector)[ele.index].style.minHeight = getMaxHeight+'px';
    });
  })

}
window.setGridHeight('.collection-matrix .product-thumbnail__title');



const myInterval = setInterval(findYotpo, 1000);

function findYotpo() {
 if(document.querySelector(".product__information .yotpo-bottomline a")){
  clearInterval(myInterval);
     document.querySelector(".product__information .yotpo-bottomline a").addEventListener('click',function(e){
        e.preventDefault()
        document.querySelector(".product_tab_content_wrap .tab").querySelectorAll('.tablinks').forEach(function(ele){
           if(ele.innerHTML=='Reviews'){
               ele.click();
           }
        })
    }); 
  }
};

// MATCH HEIGHT JS START

window.setGridHeight = (selector) => {
  this.heightArray = [];
  this.offsetArrayArray = [];
  this.sectionArray = [];

  document.querySelectorAll(selector).forEach((grid, i) => {
    var tmp = {
      index: i,
      offsetheight: grid.closest(`[data-equal]`).offsetTop,
    };
    this.offsetArrayArray.push(tmp);
  });

  this.diffrentsHeights = [];
  this.offsetArrayArray.forEach(function (e) {
    if (this.diffrentsHeights.includes(e.offsetheight) == false) {
      this.diffrentsHeights.push(e.offsetheight);
    }
  });

  this.diffrentsHeights.forEach(function (e) {
    var data = [];
    for (var i = 0; i < this.offsetArrayArray.length; i++) {
      if (this.offsetArrayArray[i].offsetheight == e) {
        data.push(this.offsetArrayArray[i]);
      }
    }

    var getAllHeightArray = [];
    data.forEach(function (ele) {
      document.querySelectorAll(selector)[ele.index].removeAttribute("style");
      getAllHeightArray.push(
        document.querySelectorAll(selector)[ele.index].offsetHeight
      );
    });

    var getMaxHeight = Math.max.apply(Math, getAllHeightArray);
    data.forEach(function (ele) {
      document.querySelectorAll(selector)[ele.index].style.minHeight =
        getMaxHeight + "px";
    });
  });
};

// window.setGridHeight(
//   ".ssl_testimonials_items .ssl_testimonial_middle_part"
// );

// MATCH HEIGHT JS END

// TESTIMONIAL SLIDER JS START

$(()=>{
  var createSlick = ()=>{
    let slider = $(".ssl_testimonials_items");

    slider.not('.slick-initialized').slick({
      autoplay: false,
      infinite: true,
      dots: true,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            adaptiveHeight: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });	
  }

  createSlick();

 $(window).on( 'resize orientationchange', createSlick );
})

$('.ssl_testimonials_items').on('init', function(event, slick){
  window.setGridHeight('.ssl_testimonials_items .ssl_testimonial_middle_part');
});

// TESTIMONIAL SLIDER JS END


//Announcement Bar USP
$('.services .services_items').slick({
          arrows: false,
          dots: false,
          slidesToShow: 4,
          cssEase: 'linear',
          slidesToScroll: 1,
          infinite: false,
          autoplay: false,
          responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 959,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 770,
          settings: {            
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ]
});
$(document).ready(function() {
  
  $('.ssl_services').css('height', 'auto');  
  $('.ssl_services').css('visibility', 'visible');  

    // Add smooth scrolling to all links
  $(".page-sleep_softgel_lander a[href^='#']").on('click', function(event) {

    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function(){
   
        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = hash;
      });
    } // End if
  });
});

// hamburger click
$(".page-sleep_softgel_lander .mobile-menu__toggle-icon").click(function(){
  $(this).toggleClass("is-active");
  $(".page-sleep_softgel_lander .mobile-menu__toggle-button").attr("data-show-mobile-menu", "true");
  $('body').toggleClass("mobile-menu--opened");
});
$(".page-sleep_softgel_lander .mobile-menu__item").click(function(){
  $('.page-sleep_softgel_lander .mobile-menu__toggle-icon').removeClass("is-active");
  $(".page-sleep_softgel_lander .mobile-menu__toggle-button").attr("data-show-mobile-menu", "false");
  $('body').removeClass("mobile-menu--opened");
});

// Curcumin Page Template Start
if ($("body").hasClass("page-curcumin-softgel-lander")) {
      $("body.page-curcumin-softgel-lander").addClass("page-sleep_softgel_lander");
}

$(".page-curcumin-softgel-lander .mobile-menu__toggle-icon").click(function(){
  $(this).toggleClass("is-active");
  $(".page-curcumin-softgel-lander .mobile-menu__toggle-button").attr("data-show-mobile-menu", "true");
  $('body').toggleClass("mobile-menu--opened");
});

$(".page-curcumin-softgel-lander .mobile-menu__item").click(function(){
  $('.page-curcumin-softgel-lander .mobile-menu__toggle-icon').removeClass("is-active");
  $(".page-curcumin-softgel-lander .mobile-menu__toggle-button").attr("data-show-mobile-menu", "false");
  $('body').removeClass("mobile-menu--opened");
});

// Curcumin Page Template End

